export default "__VITE_ASSET__BYQ10HSB__"